import { Text, VStack } from '@chakra-ui/react';
import { TooltipComponentProps, TooltipTypeEnum } from '@components/map/tooltips/tooltip.types';
import { FormattedMessage } from 'react-intl';

function ZoneTooltip({ data }: Readonly<TooltipComponentProps<TooltipTypeEnum.NO_FLY_ZONE>>) {
  const { name, level } = data;

  return (
    <VStack gap={0.5} alignItems="flex-start">
      <Text textStyle="md">{name}</Text>
      <Text textStyle="md">
        <FormattedMessage id={`noFlyZone.${level}`} />
      </Text>
    </VStack>
  );
}

export default ZoneTooltip;
